import O1HD from "./gameEngine";

export interface userData{
    _userName?:string,
    _uid?:string,
    _headUrl?:string
    _openId?:string
}

export interface releaseData{
    code?:string,
    city?:string,
    userName?:string,
    type?:string,
    portrait?:string,
    oaid?:string,
    promotionid?:string,
    callback?:string,
    ad_type?:string,
    openid?:string,
    adid?:string,
    aid?:string,
    clickid?:string,
    creativeid?:string,
    creativetype?:string,
    mpversion?:string
}

const {ccclass} = cc._decorator;

@ccclass
export default class User{

    private _data_save_key:string = "crossing-to-becom-a-king-game-user-data-key";

    private userData:userData = {
        _userName: "",
        _uid: "",
        _headUrl: ""
    }

    private _releaseData:releaseData = {
        code: "",
        city: "",
        userName: "",
        type: "",
        portrait: "",
        oaid: "",
        promotionid: "",
        callback: "",
        ad_type: "",
        adid: "",
        aid: "",
        clickid: "",
        creativeid: "",
        creativetype: "",
        mpversion: "",
        openid: ""
    }
    
    getReleaseData(){
        return this._releaseData;
    }

    setReleaseData(data:releaseData){
        for(let key in data){
            let k = data[key];
            if(k != null){
                this._releaseData[key] = data[key];
            }
        }
    }

    constructor(){
        this.loadUserDate();
    }

    updateUserDate(data:userData){
        for(let key in data){
            let d = data[key];
            this.userData[key] = d;
        }
        this.writeDate();
    }

    loadUserDate(){
        let data:userData ={
            _userName: "",
            _uid: "",
            _headUrl: ""
        }
        let dataStr:string = O1HD.getServices().localStorageSrv.getStorage(this._data_save_key) || JSON.stringify(data);
        this.userData = JSON.parse(dataStr);
        this.writeDate();
    }

    getUserDate(){
        return this.userData;
    }

    private writeDate(){
        O1HD.getServices().localStorageSrv.setStorage(this._data_save_key,JSON.stringify(this.userData));
    }

}
